import { useEffect, useState } from '@max/max';
import { getUserInfo, login } from '@nibfe/mkt-user-api';
export const useUserInfo = (needLogin = false) => {
    const [userInfo, setUserInfo] = useState({
        token: '',
        avatarURL: '',
        uuid: '',
        userId: '',
        userName: '',
        done: false,
        unionId: ''
    });
    useEffect(() => {
        // 获取用户信息
        (async () => {
            const result = await getUserInfo();
            if (result.userId) {
                setUserInfo({
                    ...result,
                    done: true
                });
            }
            else if (needLogin) {
                await login();
            }
            else {
                setUserInfo({
                    ...userInfo,
                    done: true
                });
            }
        })();
    }, []);
    return {
        userInfo
    };
};
